import { Shield, TrendingUp, FileCheck, Calculator } from 'lucide-react';

interface LogoProps {
  variant?: 'shield' | 'trend' | 'check' | 'calculator';
  size?: 'sm' | 'md' | 'lg';
  showText?: boolean;
}

export function Logo({ variant = 'shield', size = 'md', showText = true }: LogoProps) {
  const sizeClasses = {
    sm: 'w-6 h-6',
    md: 'w-8 h-8',
    lg: 'w-12 h-12'
  };

  const textSizeClasses = {
    sm: 'text-lg',
    md: 'text-xl',
    lg: 'text-3xl'
  };

  const icons = {
    shield: Shield,
    trend: TrendingUp,
    check: FileCheck,
    calculator: Calculator
  };

  const Icon = icons[variant];

  return (
    <div className="flex items-center gap-2">
      <div className="relative">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-500 to-purple-600 rounded-lg blur-sm opacity-50"></div>
        <div className="relative bg-gradient-to-br from-blue-600 to-purple-700 rounded-lg p-2">
          <Icon className={`${sizeClasses[size]} text-white`} strokeWidth={2.5} />
        </div>
      </div>
      {showText && (
        <span className={`${textSizeClasses[size]} font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent`}>
          TaxMate
        </span>
      )}
    </div>
  );
}
